import { render, staticRenderFns } from "./companyNews.vue?vue&type=template&id=eb19da7e&scoped=true"
import script from "./companyNews.vue?vue&type=script&lang=js"
export * from "./companyNews.vue?vue&type=script&lang=js"
import style0 from "./companyNews.vue?vue&type=style&index=0&id=eb19da7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb19da7e",
  null
  
)

export default component.exports